export const GET_TODO_LIST = '/api/workflow/get-todo-list';
export const RESOLVE_TODO_LIST = '/api/workflow/accept-or-reject-todo-list';
export const GET_AWAITING_LIST = '/api/workflow/get-waiting-for-approve-list';
